/**
 * ResponsavelConfigEmail Request model
 * @author gabrielbgil
 */
import {
  Resource,
  Collection,
  $,
} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'
import ResponsavelConfigEmail from '@/model/resource/ResponsavelConfigEmail'

export default class ResponsavelConfigEmailRequest extends Resource {
  readonly $name: string = 'ResponsavelConfigEmailRequest'
  readonly $endpoint = '/user/config-email/configuracao{/id}'
  $id = 0

  responsavel: Responsavel | null = null
  list: ResponsavelConfigEmail[] = []

  async populate(spinner = 'populateResponsavelConfigEmailRequest') {
    const collection = new Collection(ResponsavelConfigEmail)
    await $.await.run(() => collection.query(), spinner)
    this.list = collection.items
  }
}
